const validator = {
  mobile(value: string): string {
    if (!value.trim()) return 'شماره موبایل خود را وارد کنید';
    if (!/^09\d{9}$/.test(value)) return 'شماره موبایل اشتباه است';
    return '';
  },
  number(value: string): boolean {
    return /^\d+$/.test(value);
  },
  postalcode(value: string): string {
    if (!value.trim()) return 'کد پستی خود را وارد کنید';
    if (!/^\d{10}$/.test(value)) return 'کد پستی اشتباه است';
    return '';
  },
  email(value: string): string {
    return value
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      ) == null
      ? 'ایمیل صحیح نمی باشد'
      : '';
  },
};

export { validator };
